/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_None_TitleInputs */

const en_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Presets Found`)
};

const fr_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préréglage trouvé`)
};

const de_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellungen gefunden`)
};

const it_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset trovato`)
};

const ru_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предустановки не найдены`)
};

const es_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron ajustes preestablecidos`)
};

const zh_cn2_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到预设`)
};

const ja_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが見つかりません`)
};

const hi_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रीसेट नहीं मिला`)
};

const pt_pt2_audio_description_export_preset_none_title = /** @type {(inputs: Audio_Description_Export_Preset_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição encontrada`)
};

/**
* | output |
* | --- |
* | "No Presets Found" |
*
* @param {Audio_Description_Export_Preset_None_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_none_title = /** @type {((inputs?: Audio_Description_Export_Preset_None_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_None_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_none_title(inputs)
	if (locale === "de") return de_audio_description_export_preset_none_title(inputs)
	if (locale === "it") return it_audio_description_export_preset_none_title(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_none_title(inputs)
	if (locale === "es") return es_audio_description_export_preset_none_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_none_title(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_none_title(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_none_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_none_title(inputs)
	return en_audio_description_export_preset_none_title(inputs)
});